/* =====================================================================
   Adday: collection intro "Read more" (snippets/adday-collection-header.liquid).
   Mobile only (below 768px): clamps the intro to 2 lines with CSS
   line-clamp (.is-clamped in assets/adday-plp-header.css) and shows the
   toggle only when the text is longer than that. The full text is always
   in the DOM. Without this script the full intro shows.
   ===================================================================== */

(() => {
  const mobile = window.matchMedia('(max-width: 767px)');

  const setUp = (intro) => {
    const text = intro.querySelector('.adday-plp-intro__text');
    const toggle = intro.querySelector('.adday-plp-intro__toggle');
    if (!text || !toggle) return;

    let expanded = false;

    const measure = () => {
      if (!mobile.matches) {
        intro.classList.remove('is-clamped');
        toggle.hidden = true;
        return;
      }
      if (expanded) return;

      intro.classList.add('is-clamped');
      const overflows = text.scrollHeight > text.clientHeight + 1;
      intro.classList.toggle('is-clamped', overflows);
      toggle.hidden = !overflows;
    };

    toggle.addEventListener('click', () => {
      expanded = !expanded;
      intro.classList.toggle('is-clamped', !expanded);
      toggle.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      toggle.textContent = expanded ? toggle.dataset.labelLess : toggle.dataset.labelMore;
    });

    mobile.addEventListener('change', measure);
    measure();
  };

  const init = () => document.querySelectorAll('[data-adday-plp-intro]').forEach(setUp);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
